import React, { Component } from 'react';
import PropTypes from 'prop-types';
import l10n from '../../lib/reactPPl10nHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import poll from '../../lib/poll';

const question = l10n.getContent('smarthelp/chatBot.message.question');
const bubbleText = l10n.getContent('smarthelp/chatBot.bubble.text');
const btnText = l10n.getContent('smarthelp/chatBot.button.text');
const rejectText = l10n.getContent('smarthelp/chatBot.bubble.reject');

class ChatBot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: '',
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if (this.props.display) {
      this.chatBotTracking();
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.display === false && nextProps.display === true) {
      this.chatBotTracking();
      this.setState({ display: '' });
    }
  }

  chatBotTracking() {
    const validateFpti = () => {
      if (!window.fpti) {
        return Promise.reject(false);
      }
      return Promise.resolve(window.fpti);
    };
    return poll(validateFpti, 4, 500)
      .then(() => trackPage({ link: this.props.link, id: this.props.id, hpid: this.props.hpid }))
      .catch(() => {});
  }

  sessionChecker() { // eslint-disable-line class-methods-use-this
    const chatBotPromptClosed = sessionStorage && sessionStorage.getItem('chatBotPromptClosed') !== 'true';
    const chatBotLoaded = sessionStorage && sessionStorage.getItem('chatBotClicked') !== 'true';
    return chatBotPromptClosed && chatBotLoaded;
  }

  handleClose(e) { // eslint-disable-line class-methods-use-this
    const chatPromptCard = document.getElementById('chat-question-card');
    chatPromptCard.classList.add('fade-out');
    document.getElementById('chat-now-btn').classList.add('btn-fadein');
    sessionStorage.setItem('chatBotPromptClosed', 'true');
    chatPromptCard.style.position = 'absolute';
    chatPromptCard.style.left = '-99999px';
    e.cancelBubble = true; // otherwise, close will bubble up and invoke chat bot.
    if (e.stopPropagation) e.stopPropagation();
  }

  chatBotPrompt() {
    return (<div // eslint-disable-line jsx-a11y/no-static-element-interactions
      style={{ display: this.state.display }} id="chat-question-card" className="chat-question-card fade-in"
    >
      <button onClick={this.handleClose} className="close-btn" />
      <p className="ppl-logo" />
      <p className="chatbot-question">{question}</p>
      <p className="chatbot-text">{bubbleText}</p>
      <button onClick={this.handleClick} className="chat-question-card-btn"><span className="chat-icon" />
        <p className="btn-text">{btnText}</p></button>
      <button onClick={this.handleClose} className="reject-text">{rejectText}</button>
    </div>);
  }

  handleClick() {
    this.props.chatBotClicked();
    const chatbotClicked = sessionStorage && sessionStorage.getItem('chatBotClicked') === 'true';
    if (!chatbotClicked) {
      sessionStorage.setItem('chatBotClicked', 'true');
    }
    this.setState({ display: 'none' });
    trackLink({ link: `${this.props.link}|clicked`, id: this.props.id, hpid: this.props.hpid });
    if (!Page.isLoggedIn()) {
      return null;
    }
    // eslint-disable-next-line no-undef
    if (typeof nodeChat !== 'undefined' && nodeChat) {
      // eslint-disable-next-line no-undef
      return nodeChat.show('chatBot', this.props.topicRefId);
    }
    return null;
  }

  hideChatBot() {
    return !this.props.display || Page.disableChatbotInMobileTablet();
  }

  render() {
    if (this.hideChatBot()) {
      return null;
    }
    const chatBtnClassName = this.sessionChecker() ? 'chat-btn' : 'chat-btn btn-fadein';
    return (
      <div id="smarthelp-chatBot-prompt" className="chatBot-prompt">
        {this.sessionChecker() && this.chatBotPrompt()}
        <button style={{ display: this.state.display }} id="chat-now-btn" onClick={this.handleClick} className={chatBtnClassName}>
          <span className="chat-icon" /><p className="btn-text">{btnText}</p></button>
      </div>
    );
  }
}

ChatBot.propTypes = {
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  hpid: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired,
  chatBotClicked: PropTypes.func,
  topicRefId: PropTypes.string,
};

ChatBot.defaultProps = {
  id: '',
  link: '',
  hpid: '',
  display: false,
  topicRefId: 'GENPOOL', // GENPOOL is generic topic id
  chatBotClicked: () => {},
};

export default ChatBot;
